<template>
  <div class="c-processes-page">
    <div class="o-width-limiter">
      <div class="o-grid">
        <div data-size="sm:12 md:8 lg:8" class="o-grid__column">
          <h1 class="t-text-style-alpha t-margin-bottom-s">
            <img
              v-if="appCustomerLogotype"
              class="customer-image"
              v-bind:src="appCustomerLogotype"
              alt=""
              width="200"
              height="50"
            />
            <span class="customer-name" v-html="appTitle"></span>
          </h1>
        </div>
        <div class="o-grid__column">
          <button
            class="c-button c-button--linkstyle c-button--reset"
            type="button"
            @click="exportPdfs"
          >
            <vue-icon name="file"></vue-icon>
            <span class="c-process-item__button">Generera PDF</span>
          </button>
        </div>
      </div>
      <processes-data-provider>
        <div slot-scope="dataProvider">
          <div v-if="dataProvider.loading" class="c-spinner"></div>
          <processes
            :processes="dataProvider.processes"
            :original-process-ids="dataProvider.originalProcessIds"
            @delete="dataProvider.delete"
          ></processes>
        </div>
      </processes-data-provider>
    </div>
  </div>
</template>

<script>
import ProcessesDataProvider from './../processes-data-provider/ProcessesDataProvider.vue';
import Processes from './../processes/Processes.vue';
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';
export default {
  name: 'ProcessesPage',
  components: {
    ProcessesDataProvider,
    Processes,
    VueIcon
  },
  props: {
    apiUrl: {
      type: String,
      default: ''
    },
    companyId: {
      type: String,
      default: ''
    },
    appTitle: {
      type: String,
      default: 'Vårt ledningssystem'
    },
    appCustomerLogotype: {
      type: String,
      default: false
    }
  },
  methods: {
    exportPdfs() {
      this.$store.dispatch('processes/exportPdfs');
    }
  },
  created() {
    this.$store.dispatch('processes/setAppData', {
      apiUrl: this.apiUrl,
      companyId: this.companyId
    });
  }
};
</script>
